"use client";

// import { signIn } from "@/auth/auth";
import { Button } from "@deputy-ai/ui/button/Button";
import { signIn } from "next-auth/react";

export function SignIn() {
  // return (
  //   <form
  //     action={async () => {
  //       "use server";
  //       await signIn();
  //     }}
  //   >
  //     <Button type="submit">Sign in</Button>
  //   </form>
  // );

  return <Button onClick={async () => await signIn()}>Sign In</Button>;
}
